import { render, staticRenderFns } from "./the-form-section.vue?vue&type=template&id=0d18238e&scoped=true&"
import script from "./the-form-section.vue?vue&type=script&lang=js&"
export * from "./the-form-section.vue?vue&type=script&lang=js&"
import style0 from "./the-form-section.vue?vue&type=style&index=0&id=0d18238e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18238e",
  null
  
)

export default component.exports